import {
  FETCH_START,
  FETCH_END,
  DISTRIBUTOR_CONTRACT_DATA,
  MANAGE_CLAIMS_DATA,
  MANAGE_CLAIMS_PROFILE,
  MANAGE_CLAIMS_NEXT_STATUS,
  MANAGE_CLAIMS_USER_TABS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';
import { runGlobalAPI } from '../General/AuthAction';

const BASE_API = 'distributor-chargeback/contract';
export const DistributorTypes = (type, data) => {
  return { type, data };
};
const fetchStart = () => ({ type: FETCH_START });
const fetchEnd = () => ({ type: FETCH_END });

export const createDistributorChargebackContracts = (data, id, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createChargebackContractsAPI(data, id, type);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const createChargebackContractsAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'edit') {
    return axios.put(BASE_API, { ...data }, { headers });
  } else if (type === 'delete') {
    return axios.delete(`${BASE_API}/${id}`, { headers });
  } else {
    return axios.post(BASE_API, data, { headers });
  }
};
export const getDistributorContractItem = (id, isPendingContract) => {
  return (dispatch) => {
    dispatch(DistributorTypes(FETCH_START))
    getDistributorContractItemAPI(id, isPendingContract)
      .then((response) => {

        dispatch(DistributorTypes(DISTRIBUTOR_CONTRACT_DATA, response.data.response));

        dispatch(DistributorTypes(FETCH_END))

      })
      .catch((error) => { dispatch(DistributorTypes(FETCH_END)) });
  };
};

const getDistributorContractItemAPI = (id, isPendingContract) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const url = isPendingContract ? `${BASE_API}/${id}?is_pending_contract=true` : `${BASE_API}/${id}`;
  return axios.get(url, { headers });
};

// Process Code (Designer Studio > Distributor Chargeback)
const PROCESS_CODE_API = 'dc/process-codes';

export const createProcessCode = (data, processCode, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createProcessCodeAPI(data, processCode, type);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const createProcessCodeAPI = (data, processCode, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const url = `${PROCESS_CODE_API}/${encodeURIComponent(processCode)}`;
  if (type === 'edit') {
    return axios.put(url, data, { headers });
  } else if (type === 'delete') {
    return axios.delete(url, { headers });
  } else {
    return axios.post(PROCESS_CODE_API, data, { headers });
  }
};

export const getProcessCodeItem = (processCode) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
      };
      const response = await axios.get(`${PROCESS_CODE_API}/${encodeURIComponent(processCode)}`, { headers });
      return response?.data?.response || {};
    } finally {
      dispatch(fetchEnd());
    }
  };
};

// Communication Code (Designer Studio > Distributor Chargeback)
const COMMUNICATION_CODE_API = 'config/communication-codes';

export const createCommunicationCode = (data, communicationCode, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createCommunicationCodeAPI(data, communicationCode, type);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const createCommunicationCodeAPI = (data, communicationCode, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const url = `${COMMUNICATION_CODE_API}/${encodeURIComponent(communicationCode)}`;
  if (type === 'edit') {
    return axios.put(url, data, { headers });
  } else if (type === 'delete') {
    return axios.delete(url, { headers });
  } else {
    return axios.post(COMMUNICATION_CODE_API, data, { headers });
  }
};

export const getCommunicationCodeItem = (communicationCode) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
      };
      const response = await axios.get(`${COMMUNICATION_CODE_API}/${encodeURIComponent(communicationCode)}`, { headers });
      return response?.data?.response || {};
    } finally {
      dispatch(fetchEnd());
    }
  };
};

// ---------- Manage Claims ----------
// Failures are toasted by the axios interceptor. claims-data / process-claims respond with
// { log_number, response: [claim lines], status }; errors are HTTP errors (runGlobalAPI rethrows).

// Shared by Distributor and Manufacturer Chargeback; each has its own claims endpoints.
const CLAIMS_API_PREFIX = {
  'Distributor Chargeback': 'dc',
  'Manufacturer Chargeback': 'mc',
};
const claimsApi = (path) => `/${CLAIMS_API_PREFIX[sessionStorage.getItem('application')] || 'dc'}/${path}`;

// Run: claims-data for the global filter payload, the global way (runGlobalAPI: loader, execution
// log). Stores the claim lines (manageClaimsData) and resolves with them; rejects on failure.
export const getManageClaimsData = (data) => {
  return async (dispatch) => {
    const response = await dispatch(runGlobalAPI(data, claimsApi('claims-data')));
    const lines = response?.data?.response || [];
    dispatch(DistributorTypes(MANAGE_CLAIMS_DATA, lines));
    return lines;
  };
};

// Reprocess: the edited claim lines to process-claims. Its log_number's execution log is shown
// here (not through runGlobalAPI) so its errors decide the result. Returned lines replace the
// stored ones. Resolves with { success, lines }; success is false when the log has errors.
export const processManageClaims = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
      };
      const response = await axios.post(claimsApi('process-claims'), data, { headers });
      dispatch(fetchEnd());
      const lines = response?.data?.response || [];
      if (lines.length > 0) dispatch(DistributorTypes(MANAGE_CLAIMS_DATA, lines));
      const logNumber = response?.data?.log_number;
      if (!logNumber) return { success: true, lines };
      const { hasError } = await handleExecutionLog(dispatch, logNumber);
      return { success: !hasError, lines };
    } catch (error) {
      dispatch(fetchEnd());
      throw error;
    }
  };
};

// Claims profile for { application_type, functionality, process_code }, through the global POST
// (runGlobalAPI). Stores the response (manageClaimsProfile) and resolves with it; rejects on failure.
export const getManageClaimsProfile = (data) => {
  return async (dispatch) => {
    const response = await dispatch(runGlobalAPI(data, 'claims/process-data'));
    const profile = response?.data?.response || response?.data || null;
    dispatch(DistributorTypes(MANAGE_CLAIMS_PROFILE, profile));
    return profile;
  };
};

// User tabs (Manage tabs): one tab per call. Body: { application_type, functionality, tab_name,
// base_view, filters }. The dialog's form stays as it was on failure (rejects).
const USER_TABS_API = 'config/user-tabs';

// Saved user tabs for { application_type, functionality, process_code } (query params); they
// replace the stored profile's user_tabs. Resolves with the list.
export const getManageClaimsUserTabs = (params) => {
  return async (dispatch) => {
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    const response = await axios.get(USER_TABS_API, { headers, params });
    const tabs = response?.data?.response || [];
    dispatch(DistributorTypes(MANAGE_CLAIMS_USER_TABS, tabs));
    return tabs;
  };
};

// Updates one tab; resolves with the saved tab.
export const updateManageClaimsUserTab = (id, data) => {
  return async () => {
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    const response = await axios.put(`${USER_TABS_API}/${id}`, data, { headers });
    return response?.data?.response;
  };
};

// Deletes one tab.
export const deleteManageClaimsUserTab = (id) => {
  return async () => {
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    await axios.delete(`${USER_TABS_API}/${id}`, { headers });
  };
};

// Adds one tab through the global POST (runGlobalAPI: loader, execution log for a log_number);
// resolves with the saved tab.
export const createManageClaimsUserTab = (data) => {
  return async (dispatch) => {
    const response = await dispatch(runGlobalAPI(data, USER_TABS_API));
    return response?.data?.response;
  };
};

// Next statuses for { application_type, functionality, workflow_name, workflow_current_status },
// stored per workflow and status (manageClaimsNextStatuses) as { options, details }, with
// loading / failed while pending / after an error. Unlike getWorkflowNameData 'nextStatus', several
// statuses load side by side. No global loader: the approval drawer shows its own.
export const getManageClaimsNextStatuses = (data) => {
  return (dispatch) => {
    const store = (value) =>
      dispatch(DistributorTypes(MANAGE_CLAIMS_NEXT_STATUS, { workflowName: data.workflow_name, status: data.workflow_current_status, value }));
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    store({ options: [], details: {}, loading: true });
    return axios
      .post('config/approval-workflow/status', data, { headers })
      .then((response) => {
        const result = response?.data?.response;
        store({ options: Object.keys(result?.possible_statuses || {}), details: result?.possible_status_details || {} });
      })
      .catch(() => store({ options: [], details: {}, failed: true }));
  };
};
